module.exports = __webpack_public_path__ + "static/img/29.bf97986c.jpg";